"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareDefaultLayoutPageProps = void 0;
var _auth = require("@ori/auth");
var _mapAndValidateBaseUrls = require("../../utils/mapAndValidateBaseUrls");
var _DefaultLayoutFeature = require("./DefaultLayoutFeature");
var _internal = require("./internal");
/**
 * The function is used to constructs a object with default layout properties used by `DefaultLayout` component
 * @param props - {@link PrepareDefaultLayoutProps}
 * @returns Object typed as {@link DefaultLayoutPageProps}
 */
const prepareDefaultLayoutPageProps = ({
  page: {
    cultureSettings,
    developmentInfo,
    environment,
    features,
    language,
    pageMetaData,
    periodCode,
    servicesUrls,
    tenant,
    token,
    useLegacyKendoCulture = false,
    useLegacyTokenService = false,
    requiredServicesUrls = [],
    appLoaders,
    enableWebVitalsCollection = false,
    enableFavorites = false,
    operationId
  },
  layout: {
    languages,
    translations,
    defaultTranslations,
    componentsProps
  }
}) => ({
  page: {
    ...(pageMetaData && {
      pageMetaData
    }),
    ...(translations && {
      translations
    }),
    ...(defaultTranslations && {
      defaultTranslations
    }),
    ...(appLoaders && {
      appLoaders
    }),
    cultureSettings,
    language,
    customerId: _auth.NOT_LOGGED_IN_USER_ID,
    developmentInfo,
    environment,
    features: [...features.values()],
    isProduction: process.env.NODE_ENV === 'production',
    pageBuiltAt: new Date().toString(),
    pageFeatures: _DefaultLayoutFeature.DefaultLayoutFeature,
    periodCode,
    servicesUrls: (0, _mapAndValidateBaseUrls.mapAndValidateBaseUrls)(servicesUrls, [..._internal.defaultLayoutRequiredServices, ...requiredServicesUrls]),
    tenant,
    token,
    useLegacyKendoCulture,
    useLegacyTokenService,
    enableWebVitalsCollection,
    enableFavorites,
    operationId
  },
  layout: {
    ...(languages && {
      languages
    }),
    ...(componentsProps && {
      componentsProps
    })
  }
});
exports.prepareDefaultLayoutPageProps = prepareDefaultLayoutPageProps;
